import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import RewardHistoryCard from '../../admin/components/report/RewardHistoryCard';

const UserCompensationHistory = ({ client, token }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false)

    useEffect(() => {
        if (!client || !client.user_reward) history.push("/client");
    }, [])

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={e => setToggled(!toggled)} />
            <div className="admin-page">
                <Topbar handleToggle={e => setToggled(!toggled)} />
                <div className="admin-content">
                    <RewardHistoryCard
                        authtoken={token}
                        stamp={client?.stamp}
                        etoken={client?.token}
                        point={client?.loyalty_point}
                        role="client"
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};

export default connect(mapStateToProps, null)(UserCompensationHistory);
